import React from 'react';
import { Spin } from 'antd';
import { useDocument } from 'react-firebase-hooks/firestore';

import { LayoutPage, LayoutGrid } from 'components/layouts';
import Client from 'containers/app/client';
import UserItem from './user-item';

const SendTokens = () => {
  const ref = Client.dbProfile();
  const [doc, loading, error] = useDocument(ref);
  const [docOrg, loadingOrg, errorOrg] = useDocument(
    doc &&
      doc.data().organization &&
      Client.dbDoc(`organizations/${doc.data().organization}`)
  );

  if (loading || loadingOrg) return <Spin />;

  if (error) throw new Error(error);
  if (errorOrg) throw new Error(errorOrg);
  if (docOrg == null) return <Spin />;

  const {
    admins: { users },
  } = docOrg.data();

  return (
    <LayoutPage className="send-tokens-page">
      <LayoutPage.Container className="wrapper">
        <h1>Send Tokens</h1>
        <LayoutGrid className="user-list">
          {users.map(({ uid }) => (
            <UserItem key={uid} uid={uid} />
          ))}
        </LayoutGrid>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default SendTokens;
